module.exports = __webpack_public_path__ + "static/img/Bailey-Wright.20e18db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bailey-Wright.jpg
// module id = PUvx
// module chunks = 0